import React from 'react';
import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemType } from '@src/framework/workbench/drawer/constants';
import { config as boldConfig } from '@src/framework/workbench/ui/bold/config';
import { config as italicConfig } from '@src/framework/workbench/ui/italic/config';
import { config as underlineConfig } from '@src/framework/workbench/ui/underline/config';
import { config as deletelineConfig } from '@src/framework/workbench/ui/delete-line/config';
import { config as subscriptConfig } from '@src/framework/workbench/ui/subscript/config';
import { config as superscriptConfig } from '@src/framework/workbench/ui/superscript/config';
import { config as fontIncreaseConfig } from '@src/framework/workbench/ui/font-size-increase/config';
import { config as fontDereaseConfig } from '@src/framework/workbench/ui/font-size-decrease/config';
import {
    BOLD_ICON,
    ITALIC_ICON,
    UNDERLINE_ICON,
    DELETELINE_ICON,
    FONT_SIZE_DECREASE_ICON,
    FONT_SIZE_INCREASE_ICON,
} from '@src/framework/workbench/drawer/image';
import Style from '@framework/workbench/drawer/ui/index.less';
import { COMMON_STYLE, ALIGN_BUTTON_STYLE } from '@framework/workbench/drawer/common/config';
import { TOOLBAR_SUBSCRIPT, TOOLBAR_SUPERSCRIPT } from '@src/framework/editor/src/img/pageIndex';

export const FORM_CONFIGS_BOLD: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: boldConfig.id,
        options: {
            icon: <img src={BOLD_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: boldConfig.tipMsg,
        preventFocus: true,
        style: COMMON_STYLE,
    },
];

export const FORM_CONFIGS_ITALIC: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: italicConfig.id,
        options: {
            icon: <img src={ITALIC_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: italicConfig.tipMsg,
        preventFocus: true,
        style: COMMON_STYLE,
    },
];

export const FORM_CONFIGS_UNDERLINE: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: underlineConfig.id,
        options: {
            icon: <img src={UNDERLINE_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: underlineConfig.tipMsg,
        preventFocus: true,
        style: COMMON_STYLE,
    },
];

export const FORM_CONFIGS_DELETLINE: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: deletelineConfig.id,
        options: {
            icon: <img src={DELETELINE_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: deletelineConfig.tipMsg,
        preventFocus: true,
        style: COMMON_STYLE,
    },
];

export const FORM_CONFIGS_SUBSCRIPT: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: subscriptConfig.id,
        options: {
            icon: <img src={TOOLBAR_SUBSCRIPT} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: subscriptConfig.tipMsg,
        preventFocus: true,
        style: COMMON_STYLE,
    },
];

export const FORM_CONFIGS_SUPERSCRIPT: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: superscriptConfig.id,
        options: {
            icon: <img src={TOOLBAR_SUPERSCRIPT} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: superscriptConfig.tipMsg,
        preventFocus: true,
        style: COMMON_STYLE,
    },
];

export const FORM_CONFIGS_FONT_INCREASE: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: fontIncreaseConfig.id,
        options: {
            icon: <img src={FONT_SIZE_INCREASE_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        style: ALIGN_BUTTON_STYLE,
        tooltip: fontIncreaseConfig.tipMsg,
        preventFocus: true,
    },
];

export const FORM_CONFIGS_FONT_DECREASE: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: fontDereaseConfig.id,
        options: {
            icon: <img src={FONT_SIZE_DECREASE_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        style: ALIGN_BUTTON_STYLE,
        tooltip: fontDereaseConfig.tipMsg,
        preventFocus: true,
    },
];
